export function sortByCriteria(arr, criteria, order = false) {
    //order가 true면 오름차순, false면 내림차순
    if (order === false) return arr.sort((a, b) => a[criteria] - b[criteria]);
    return arr.sort((a, b) => a[criteria] + b[criteria]);
}

export function sortXorY(arr, x, y, order = false) {
    if (!Array.isArray(arr)) return undefined;

    if (order === false)
        return arr.sort((a, b) => (a[x] === b[x] ? a[y] - b[y] : a[x] - b[x]));

    return arr.sort((a, b) => (a[x] === b[x] ? a[y] + b[y] : a[x] + b[x]));
}

export function sortXnY(arr, x, y, order = false) {
    if (!Array.isArray(arr)) return undefined;

    if (order === false) {
        return arr.sort((a, b) =>
            a[x] === b[x] ? a[y] - b[y] : a[x] - b[x] && a[y] - b[y]
        );
    }
    return arr.sort((a, b) =>
        a[x] === b[x] ? a[y] + b[y] : a[x] + b[x] && a[y] + b[y]
    );
}
